import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  footer: {
    bottom: "0",
    width: "100%",
    padding: "10px",
    textAlign: "center"
    // You can add additional styling for the footer here
  }
});

export default useStyles;
